module.exports = __webpack_public_path__ + "static/media/nodeDummyBdd.12e1bc8e.png";